export const environment = {
    production :false,
    baseUrl: 'https://stomp-dev-api.sdukdev.co.uk/api/v1'
};
